import { CustomFieldResourceType } from "@wingspanhq/payments/dist/interfaces";
import React from "react";
import { RouteComponentProps } from "react-router";
import { queriesPayables } from "@query";
import { WSQueries } from "../../../query/WSQuery";
import { useQueryCustomFieldsAll } from "../../../query/customFields/queries/useQueryCustomFieldsAll";
import { useXWingspanPayerId } from "../../../modules/Payees/routes/RoutePayeeDetails/useXWingspanPayerId";
import { PayableForm } from "../../components/PayableForm/PayableForm";

export const EditPayable: React.FC<
  RouteComponentProps<
    {
      payableId: string;
    },
    any,
    {
      backPath?: string;
    }
  >
> = ({ match, location }) => {
  const payableId = match.params.payableId;
  const xWingspanAccount = useXWingspanPayerId();
  const payableQuery = queriesPayables.getPayable.useQuery({
    payableId,
    xWingspanAccount
  });
  const queryCustomFields = useQueryCustomFieldsAll({
    resourceType: [CustomFieldResourceType.LineItem]
  });

  const backPath = location.state?.backPath;

  return (
    <WSQueries queries={{ payableQuery, queryCustomFields }}>
      {({
        payableQuery: { data: payable },
        queryCustomFields: { data: customFields }
      }) => (
        <PayableForm
          backPath={backPath}
          payable={payable}
          customFields={customFields}
        />
      )}
    </WSQueries>
  );
};
